import { Routes, Route, Navigate } from 'react-router-dom'
import { MainLayout } from './MainLayout'
import { HomePage } from '../features/HomePage'
import { AvatarPage } from '../features/AvatarPage'
import { ConnectionsPage } from '../features/ConnectionsPage'
import { EnhancedChatPage } from '../features/EnhancedChatPage'
import { NotFoundPage } from '../features/NotFoundPage'

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<HomePage />} />
        <Route path="/avatar" element={<AvatarPage />} />
        <Route path="/connections" element={<ConnectionsPage />} />
        <Route path="/chat" element={<EnhancedChatPage />} />
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Route>
    </Routes>
  )
}